const ThankYou = () => import("./pages/ThankYou.vue");
const UserDetails = () => import("./pages/UserDetails.vue");

export const UpgradAimlRoutes = [
  {
    path: "/upgrad-aiml",
    component: UserDetails,
    meta: {
      title: "Upgrad"
    }
  },
  {
    path: "/upgrad-aiml/thankyou",
    component: ThankYou
  }
];
